import { QueryClient } from '@tanstack/react-query'
import { AllIndexedDBTables } from '../types'

export const indexedDBQueryKeyRoot = 'indexed-db'

/** Utility method to build a query key for an IndexedDB table. */
export const indexedDBQueryKey = (
  table: AllIndexedDBTables,
  params?: Record<string, unknown>
) => [indexedDBQueryKeyRoot, table, params ?? {}]

/** Invalidate caches of all queries for an IndexedDB table. */
export const invalidateIndexedDBTableCache = (
  queryClient: QueryClient,
  table: AllIndexedDBTables
) => queryClient.invalidateQueries({ queryKey: indexedDBQueryKey(table) })

/**
 * Invalidate a cache for an IndexedDB table record by query params.
 */
export const invalidateIndexedDBRecordCache = (
  queryClient: QueryClient,
  table: AllIndexedDBTables,
  params?: Record<string, unknown>
) =>
  queryClient.invalidateQueries({ queryKey: indexedDBQueryKey(table, params) })
